export type RememberedSide = 'buying' | 'selling';

// [MCV-1889] The Buying | Selling tab a page reopens on. Like the saved provider search (MCV-1882)
// it lives in sessionStorage keyed by viewer, so another user or role in the browser never opens
// on this one's tab.
const keyFor = (page: 'marketplace' | 'responses', viewerScopeKey: string) =>
  `hlx.b2b.${page}Side.v1:${viewerScopeKey}`;

export const parseRememberedSide = (value: string | null | undefined): RememberedSide | null =>
  value === 'buying' || value === 'selling' ? value : null;

// A convenience: a blocked or empty store must never break the page.
export const readRememberedSide = (
  page: 'marketplace' | 'responses',
  viewerScopeKey: string
): RememberedSide | null => {
  try {
    return parseRememberedSide(window.sessionStorage.getItem(keyFor(page, viewerScopeKey)));
  } catch {
    return null;
  }
};

export const storeRememberedSide = (
  page: 'marketplace' | 'responses',
  viewerScopeKey: string,
  side: RememberedSide
) => {
  try {
    window.sessionStorage.setItem(keyFor(page, viewerScopeKey), side);
  } catch {
    // Not remembered; the page still works.
  }
};
